export default __webpack_public_path__ + "static/media/steps-plane.fbfb1d38.svg";